// Shared inline-style fragments so the 14 pages don't each redefine the same
// eyebrow/heading/body treatment -- ported from the repeated patterns in the
// Claude Design prototype.
export const eyebrow = {
  fontSize: 11,
  letterSpacing: '.22em',
  textTransform: 'uppercase',
  color: 'var(--rose-600)',
};

export const h1 = {
  fontFamily: 'var(--font-display)',
  fontWeight: 300,
  fontSize: 'clamp(34px, 5.6vw, 60px)',
  lineHeight: 1.08,
  color: 'var(--ink-900)',
  margin: '14px 0 12px',
};

export const h2 = {
  fontFamily: 'var(--font-display)',
  fontWeight: 300,
  fontSize: 'clamp(28px, 4.2vw, 46px)',
  lineHeight: 1.12,
  color: 'var(--ink-900)',
  margin: 0,
};

export const bodyText = {
  fontSize: 16,
  lineHeight: 1.7,
  color: 'var(--ink-600)',
};

export const pageWrap = {
  padding: '5vw',
  maxWidth: 1240,
  margin: '0 auto',
};

export const card = {
  background: '#FFF',
  border: '1px solid var(--ink-200)',
  borderRadius: 'var(--radius-xl)',
  boxShadow: 'var(--shadow-sm)',
};

export const pillButtonPrimary = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 10,
  background: 'var(--rose-700)',
  color: '#FFF',
  fontSize: 14,
  letterSpacing: '.06em',
  padding: '15px 28px',
  borderRadius: 'var(--radius-pill)',
  textDecoration: 'none',
  whiteSpace: 'nowrap',
  border: 'none',
  cursor: 'pointer',
  fontFamily: 'inherit',
};

export const pillButtonSecondary = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 10,
  background: 'transparent',
  border: '1px solid var(--rose-300)',
  color: 'var(--rose-700)',
  fontSize: 14,
  letterSpacing: '.06em',
  padding: '15px 28px',
  borderRadius: 'var(--radius-pill)',
  textDecoration: 'none',
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  fontFamily: 'inherit',
};
